/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import {
  setDoc,
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  writeBatch,
} from "firebase/firestore";
import Pagination from "@mui/material/Pagination";
import { Tooltip } from "react-tooltip";
import Stack from "@mui/material/Stack";
import { db } from "../../../firebase";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import usePagination from "../../helper/paginate/Pagination";
import "./DataTableDemo.css";
import { Link } from "react-router-dom";
import { ComponentToPrint } from "./ComponentToPrint";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import { confirmAlert } from "react-confirm-alert"; // Import
import { CSVLink, CSVDownload } from "react-csv";
import { fetchDate } from "../../../utils/globleFunc";
import { datat } from "./data";
import { CommuneZimou } from "./communeZimou";
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment";
import "moment/locale/fr"; // استيراد اللغة الفرنسية
import "moment/locale/ar"; // استيراد اللغة العربية
import apicache from "../../../components/clearCach/clear";
import { useTranslation } from "react-i18next";
import { Menu, Dropdown, message } from "antd";
import freeCountries from "../../../utils/freeCountries.json";
import useIsDark from "../../../utils/isDark";
import { GoogleSheetButtons } from "./googleSheetButton";
import { fetchAccount } from "../../../redux/account/account";
import { fetchOrders } from "../../../redux/orders/orders";
import { consumeSubscriptionToken } from "../../../utils/subscriptionPayment_abndn";
import { DHD_PLAN_NAME } from "../../DhdCurrentPlanBanner";
import {
  printDhdBordereaux,
  isDhdOrder,
} from "../../../utils/printDhdBordereaux";

const DataTableTemplatingDemo = ({
  filter,
  orders,
  pageSize,
  setData,
  setLgShow,
  onStatusChange = () => {},
}) => {
  const { t, i18n } = useTranslation();
  const url =
    "https://orders-management-dev.maystro-delivery.com/api/stores/orders/";
  const url1 = "https://backend.foorweb.store/api/UploadLivraison";
  const url4 = "https://app.noest-dz.com/api/public/create/order";
  const url5 = "https://backend.foorweb.store/api/UploadLivraison";
  const products = useSelector((state) => state.ProductsReducer);
  const account = useSelector((state) => state.AccountReducer);
  const isDhdUser =
    account?.subscription?.plan === DHD_PLAN_NAME &&
    account?.subscription?.dhdPartnershipActive === true;

  const [isPrintingBordereaux, setIsPrintingBordereaux] = useState(false);
  const ordersState = useSelector((state) => state.OrdersReducer || []);
  const isFreeCountry = freeCountries.includes(account?.country);
  const store = useSelector((state) => state.StoreReducer);
  const dispatch = useDispatch();
  const [expandedRows, setExpandedRows] = useState(null);
  const [bug, setBug] = useState(true);
  const productdata = useSelector((state) => state.ProductsReducer);
  const [bluck, setBluck] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);
  let [page, setPage] = useState(1);
  const PER_PAGE = pageSize;
  const count = Math.ceil(orders.length / PER_PAGE);
  const _DATA = usePagination(orders, PER_PAGE);
  const [showSubmenus, setShowSubmenus] = useState({});
  const isDark = useIsDark();
  const isRTL = i18n.dir();
  const [unlockingOrderIds, setUnlockingOrderIds] = useState({});
  const currencyMap = {
    دج: {
      ar: "دج",
      fr: "DA",
      en: "DZD",
    }, 
  };
  const localizedCurrency =
    currencyMap[store.currencySymbol]?.[i18n.language] || store.currencySymbol;

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };
  const [sentToSheet, setSentToSheet] = useState(new Set());
  const [currentDate, setCurrentDate] = useState("");
  useEffect(() => {
    const fetchAndSetCurrentDate = async () => {
      const res = await fetchDate();
      setCurrentDate(res);
    };

    fetchAndSetCurrentDate();

    const interval = setInterval(() => fetchAndSetCurrentDate(), 60000); // Fetch date every minute
    return () => clearInterval(interval); // Cleanup function
  }, []);

  const dhdSelected = selectedProducts.filter(isDhdOrder);
  const canPrintDhd = isDhdUser && dhdSelected.length > 0;

  const handlePrintDhdBordereaux = async () => {
    if (!canPrintDhd || isPrintingBordereaux) return;

    const trackings = dhdSelected
      .map((o) => o.tracking)
      .filter((t) => t && String(t).trim());

    if (trackings.length === 0) {
      Swal.fire({
        icon: "warning",
        title: t("orders.datatable_templating_demo.error"),
        text: t("orders.datatable_templating_demo.print_dhd_no_tracking"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      return;
    }

    setIsPrintingBordereaux(true);
    try {
      await printDhdBordereaux(
        trackings,
        process.env.REACT_APP_BACKEND_DIGITALOCEAN_URL,
        account?.user,
      );
    } catch (err) {
      const code = err?.code;
      let text = err?.serverMessage || err?.message || String(err);

      if (code === "NO_TRACKINGS") {
        text = t("orders.datatable_templating_demo.print_dhd_no_tracking");
      } else if (code === "NOT_AUTHENTICATED") {
        text = t(
          "orders.datatable_templating_demo.print_dhd_not_authenticated",
        );
      } else if (
        typeof text === "string" &&
        text.includes("Ecotrack credentials")
      ) {
        text = t(
          "orders.datatable_templating_demo.print_dhd_missing_credentials",
        );
      }

      Swal.fire({
        icon: "error",
        title: t("orders.datatable_templating_demo.error"),
        text,
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } finally {
      setIsPrintingBordereaux(false);
    }
  };

  const statusBodyTemplate = (rowData) => {
    let color = "#fff";
    if (rowData.deleveryStatus === "1") {
      color = "#fff";
    }
    if (rowData.deleveryStatus === "2") {
      color = "#e1a626";
    }
    if (rowData.deleveryStatus === "3") {
      color = "#25c7bf";
    }
    if (rowData.deleveryStatus === "4") {
      color = "#8c5fa5";
    }
    if (rowData.deleveryStatus === "5") {
      color = "#49a688";
    }
    if (rowData.deleveryStatus === "6") {
      color = "#e87778";
    }
    if (rowData.deleveryStatus === "11-1") {
      color = "#0074D9";
    }
    if (rowData.deleveryStatus === "11-2") {
      color = "#D3D3D9";
    }
    if (rowData.deleveryStatus === "11-3") {
      color = "#e1a626";
    }
    if (rowData.deleveryStatus === "11-4") {
      color = "#000000";
    }
    if (rowData.deleveryStatus === "11-5") {
      color = "#800080";
    }
    if (rowData.deleveryStatus === "11") {
      color = "#e1a626";
    }
    return (
      <Form.Select
        aria-label={t("ship.order_status")}
        className={
          rowData.deleveryStatus === "1" ? `text-dark n-status` : `text-white `
        }
        value={rowData.deleveryStatus}
        onChange={(e) => {
          changeStatus(rowData, e.target.value);
        }}
        style={{
          backgroundColor: `${color}`,
          zIndex: "9000",
        }}
      >
        {rowData.deleveryStatus !== "5" && (
          <>
            <option value="1">
              {t("orders.datatable_templating_demo.new")}
            </option>
            <option value="3">
              {t("orders.datatable_templating_demo.confirmed")}
            </option>
            <option value="9">
              {t("orders.datatable_templating_demo.confirmed_by_customer")}
            </option>
            <option value="11-2">
              {t("orders.datatable_templating_demo.no_response_to_call")}
            </option>
            <option value="11-3">
              {t("orders.datatable_templating_demo.postponed")}
            </option>
            {rowData.deleveryStatus !== "5" && (
              <option value="6">
                {t("orders.datatable_templating_demo.cancelled")}
              </option>
            )}
            <option value="11-5">
              {t("orders.datatable_templating_demo.cancelled_by_customer")}
            </option>
            <option value="11-1">
              {t("orders.datatable_templating_demo.awaiting_customer_contact")}
            </option>
            <option value="11-4">
              {t("orders.datatable_templating_demo.line_busy")}
            </option>
            <option value="4">
              {t("orders.datatable_templating_demo.with_delivery_company")}
            </option>
          </>
        )}
        <option value="5">
          {t("orders.datatable_templating_demo.completed")}
        </option>
      </Form.Select>
    );
  };

  const paidBodyTemplate = (rowData) => {
    let color = "#474747";
    if (rowData.paid === "0") {
      color = "#474747";
    }
    if (rowData.paid === "1") {
      color = "#19a886";
    }
    return (
      <Form.Select
        aria-label={t("ship.order_status")}
        value={rowData.paid}
        onChange={(e) => {
          changepaid(rowData, e.target.value);
        }}
        className={`text-white`}
        style={{ backgroundColor: `${color}` }}
      >
        <option value="0">
          {t("orders.datatable_templating_demo.not_paid")}
        </option>
        <option value="1">{t("orders.datatable_templating_demo.paid")}</option>
      </Form.Select>
    );
  };

  moment.defineLocale("fr-num", {
    parentLocale: "fr",
    months: moment.locales("fr").months,
    monthsShort: moment.locales("fr").monthsShort,
    weekdays: moment.locales("fr").weekdays,
    weekdaysShort: moment.locales("fr").weekdaysShort,
    weekdaysMin: moment.locales("fr").weekdaysMin,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY-MM-DD",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm",
    },
    relativeTime: {
      future: "dans %s",
      past: "il y a %s",
      s: "quelques secondes",
      ss: "%d secondes",
      m: "une minute",
      mm: "%d minutes",
      h: "une heure",
      hh: "%d heures",
      d: "un jour",
      dd: "%d jours",
      M: "un mois",
      MM: "%d mois",
      y: "une année",
      yy: "%d années",
    },
    preparse: function (string) {
      return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
        return "٠١٢٣٤٥٦٧٨٩".indexOf(match);
      });
    },
  });

  const dateBodyTemplate = (rowData) => {
    const timestamp = rowData.timeStamp.seconds * 1000;
    const now = Date.now();
    const date = moment(timestamp).locale("fr-num"); // تعيين اللغة الفرنسية مع الأرقام

    const diff = now - timestamp;

    if (diff < 60000) {
      // أقل من دقيقة واحدة
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {Math.floor(diff / 1000)}{" "}
          {t("orders.datatable_templating_demo.seconds")}
        </span>
      );
    } else if (diff < 3600000) {
      // أقل من ساعة واحدة
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {Math.floor(diff / 60000)}{" "}
          {t("orders.datatable_templating_demo.minutes")}
        </span>
      );
    } else if (diff < 86400000) {
      // أقل من يوم واحد
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {Math.floor(diff / 3600000)}{" "}
          {t("orders.datatable_templating_demo.hours")}
        </span>
      );
    } else if (diff < 604800000) {
      // أقل من أسبوع واحد
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {Math.floor(diff / 86400000)}{" "}
          {t("orders.datatable_templating_demo.days")}
        </span>
      );
    } else if (diff < 604800000 + 86400000) {
      // أقل من أسبوع واحد
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {t("orders.datatable_templating_demo.a_week")}
        </span>
      );
    } else {
      return <span>{date.format("YYYY-MM-DD, H:mm:ss")}</span>;
    }
  };

  const changeShip = async (data, status) => {
    const adresse = data.address ? data.address : ".";

    let productDetails = "";

    if (Array.isArray(data.products) && data.products.length > 0) {
      data.products.forEach((product, index) => {
        let productName = product.name;
        const quantity = product.quantity;

        if (data.stockDelivery === true) {
          productDetails = product.sku;
          return;
        }
        // ! إذا كان هناك منتج واحد، استخدم الاسم بالكامل بدون تقصير
        if (data.products.length === 1) {
          productName = product.name;
        } else if (productName.length > 10) {
          // ! تقصير اسم المنتج إلى 10 أحرف وإضافة ثلاث نقاط إذا كان أطول من ذلك
          productName = productName.substring(0, 15) + "...";
        }

        // ! الحصول على اللون مباشرةً كسلسلة
        const color = product.options?.color || "";

        // ! الحصول على الحجم مباشرةً كسلسلة
        const size = product.options?.size || "";

        const offer = product.options?.offer
          ? `العرض: ${product?.options?.offer}`
          : "";

        // ! تجميع التفاصيل ووضعها بين قوسين
        const details = `(${productName} × ${quantity} ${
          color && `+ ${color}`
        } ${size && `+ ${size}`} ${offer && `+ ${offer}`})`;

        // ! إضافة المنتج إلى السلسلة النهائية مع '+' بين المنتجات
        productDetails += details;

        // ! إضافة '+' إذا لم يكن هذا هو المنتج الأخير
        if (index < data.products.length - 1) {
          productDetails += " + ";
        }
      });
    }

    var totalNumber = Number(data.total);
    if (status === "1") {
      axios
        .post(
          url,
          {
            source: 4,
            destination_text: adresse,
            product_price: `${data.total - data.deleveryPrice}`,
            customer_name: data.name,
            customer_phone: data.phone,
            express: false,
            wilaya: datat.filter((d) => d.wilaya_name === data.state)[0].fields
              .wilaya,
            commune: parseInt(
              datat.filter((d) => d.commune_name === data.commune)[0].pk,
            ),
            note_to_driver: data.note,
            products: [
              {
                product_id: data.sku,
                logistical_description: productDetails,
                quantity: data.qty,
              },
            ],
          },
          {
            headers: {
              Authorization: `Token ${store.Maystro}`,
            },
          },
        )

        .then((response) => {
          const updatedOrder = { ...data, DC: status };
          setDoc(doc(db, "orders", data.id), updatedOrder);
          onStatusChange(data.id, updatedOrder);
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (status === "2") {
      const headers = {
        "zr-express-token": `${store.Zrexpress}`,
        "zr-express-cle": `${store.ZrexpressC}`,
        "Content-Type": "application/json",
      };

      const postData = {
        keyword: "zrexpress",
        data: {
          Colis: [
            {
              // Premier Colis
              TypeLivraison: data.stopdeskDelivery ? "1" : "0", // Domicile : 0 & Stopdesk : 1
              TypeColis: "0", // Echange : 1
              Confrimee: "", // 1 pour les colis Confirmer directement en pret a expedier
              Client: data.name,
              MobileA: data.phone,
              MobileB: data.phone,
              Adresse: adresse,
              IDWilaya: datat.filter((d) => d.wilaya_name === data.state)[0]
                .wilaya_code,
              Commune: datat.filter((d) => d.commune_name === data.commune)[0]
                .commune_name_ascii,
              Total: data.total,
              Note: data.note,
              TProduit: `${productDetails}`,
              id_Externe: "01", // Votre ID ou Tracking
              Source: "",
            },
          ],
        },
      };

      axios
        .post(url1, postData, { headers })
        .then((response) => {
          setDoc(doc(db, "orders", data.id), { ...data, DC: status });
        })
        .catch((error) => {
          console.error(error);
        });
    } else if (status === "4") {
      axios
        .post(url4, {
          user_guid: `${store.Userguid}`,
          api_token: `${store.ApitokenNord}`,
          type_id: 1,
          stop_desk: data.stopdeskDelivery ? 1 : 0,
          produit: `${productDetails}`,
          client: data.name,
          phone: data.phone,
          quantite: data.qty,
          adresse: adresse,
          wilaya_id: datat.filter((d) => d.wilaya_name === data.state)[0]
            .wilaya_code,
          commune: datat.filter((d) => d.commune_name === data.commune)[0]
            .commune_name_ascii,
          montant: data.total,
          NoteClient: data.note,
          Remboursement: 0,
          poids: `0`,
        })
        .then((response) => {
          const updatedOrder = { ...data, DC: status };
          setDoc(doc(db, "orders", data.id), updatedOrder);
          onStatusChange(data.id, updatedOrder);
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (status === "3") {
      axios
        .post(
          `${store.Uecotrack}/api/v1/create/order?api_token=${
            store.Ecotrack
          }&reference&nom_client=${data.name}&telephone=${
            data.phone
          }&telephone_2=${data.phone}&adresse=${adresse}&code_postal&commune=${
            datat.filter((d) => d.commune_name === data.commune)[0]
              .commune_name_ascii
          }&code_wilaya=${
            datat.filter((d) => d.wilaya_name === data.state)[0].wilaya_code
          }&montant=${data.total}&remarque=${
            data.note
          }&produit=${productDetails}&stock&quantite=${
            data.qty
          }&produit_a_recupere&boutique&type=1&stop_desk=${
            data.stopdeskDelivery ? 1 : 0
          }`,
        )
        .then((response) => {
          if (response.status === 200) {
            setDoc(doc(db, "orders", data.id), {
              ...data,
              DC: status,
              tracking: response.data.tracking,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (status === "5") {
      const postData = {
        keyword: "yalidine",
        data: [
          {
            order_id: "MyFirstOrder",
            firstname: ".",
            familyname: data.name,
            contact_phone: data.phone,
            address: adresse,
            to_commune_name: datat.filter(
              (d) => d.commune_name === data.commune,
            )[0].commune_name_ascii,
            to_wilaya_name: datat.filter((d) => d.wilaya_name === data.state)[0]
              .wilaya_name_ascii,
            product_list: `${productDetails}`,
            price: data.total,
            do_insurance: false,
            declared_value: data.total,
            freeshipping: data.deliveryPrice == 0 ? true : false,
            is_stopdesk: data.stopdeskDelivery ? data.stopdeskDelivery : false,
            stopdesk_id: 0,
            has_exchange: false,
            product_to_collect: null,
          },
        ],
      };

      axios
        .post(url5, postData, {
          headers: {
            "yalidine-id": store.Yalidineid,
            "yalidine-token": store.Yalidinetoken,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          setDoc(doc(db, "orders", data.id), { ...data, DC: status });
        })
        .catch((error) => {
          console.error("Error in Axios request:", error);
        });
    } else if (status === "6") {
      const postData = [
        {
          order_id: "MyFirstOrder",
          from_wilaya_name: `${store.ApitokenGW}`,
          firstname: ".",
          familyname: data.name,
          contact_phone: data.phone,
          address: adresse,
          to_commune_name: datat.filter(
            (d) => d.commune_name === data.commune,
          )[0].commune_name_ascii,
          to_wilaya_name: datat.filter((d) => d.wilaya_name === data.state)[0]
            .wilaya_name_ascii,
          product_list: `${productDetails}`,
          price: totalNumber,
          do_insurance: false,
          declared_value: totalNumber,
          freeshipping: data.deliveryPrice == 0 ? true : false,
          is_stopdesk: data.stopdeskDelivery ? data.stopdeskDelivery : false,
          has_exchange: 0,
          product_to_collect: null,
        },
      ];

      axios
        .post(
          url6,
          {
            keyword: "gupex",
            data: [postData],
          },
          {
            headers: {
              "gupex-id": store.UserguidGuepex,
              "gupex-token": store.Apitokenguepex,
              "Content-Type": "application/json",
            },
          },
        )
        .then((response) => {
          setDoc(doc(db, "orders", data.id), { ...data, DC: status });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (status === "7") {
      axios
        .post(
          `https://api.elogistia.com/insertCommande/?apiKey=${
            store.apielogistia
          }&name=${data.name}&firstname=a&mail=foorwebs@gmail.com&phone=${
            data.phone
          }&address=${adresse}&commune=${
            datat.filter((d) => d.commune_name === data.commune)[0]
              .commune_name_ascii
          }&fraisDeLivraison=0&remarque=${data.note}&stop_desk=${
            data.stopdeskDelivery ? 2 : 1
          }&wilaya=${
            datat.filter((d) => d.wilaya_name === data.state)[0].wilaya_code
          }&product=${productDetails}&price=${
            data.total
          }&modeDeLivraison=1&exchangeName=&IdCommande=1052847`,
        )
        .then((response) => {
          if (response.status === 200) {
            setDoc(doc(db, "orders", data.id), { ...data, DC: status });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (status === "8") {
      const communeArabicName = data.commune;
      // البحث في CommuneZimou عن البلدية التي لها نفس الولاية ونفس الاسم
      const matchedCommune = CommuneZimou.find((c) => {
        const datatCommune = datat.find(
          (d) => d.commune_name === communeArabicName,
        );
        return (
          datatCommune &&
          c.wilaya_id === parseInt(datatCommune.wilaya_code) &&
          c.name === datatCommune.commune_name_ascii
        );
      });
      const commune_id = matchedCommune ? matchedCommune.id : null;
      const postData = {
        order_id: "", // أو أي مرجع فريد لديك
        package_type: 4,
        client_first_name: ".",
        client_last_name: data.name,
        client_address: adresse,
        delivery_type_id: 2,
        wilaya_id: parseInt(
          datat.filter((d) => d.wilaya_name === data.state)[0].wilaya_code,
        ),
        commune_id: commune_id,
        client_phone: data.phone,
        products: [
          {
            product_id: parseInt(data.sku),
            price: parseInt(data.total),
            quantity: 1,
          },
        ],
        price: parseInt(data.total),
        can_be_opened: "0", // حسب طلب Zimou، يجب أن تكون سلسلة
        free_delivery: "1", // نفس الشيء
        source: "Foorweb",
        notes: data.note || "",
      };

      axios
        .post("https://dev.zimou.express/api/v1/packages", postData, {
          headers: {
            Authorization: `Bearer ${store.zimouToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          const tracking = response.data?.data?.id;
          if (tracking) {
            setDoc(doc(db, "orders", data.id), {
              ...data,
              deleveryStatus: "4",
              tracking: tracking,
              DC: status,
            });
          } else {
            setErrorMessage(t("ui.zimouNoTracking"));
          }
        })
        .catch((error) => {
          console.error(error.response?.data || error.message);
          // Show success notification
          Swal.fire({
            icon: "success",
            title: t("ui.orderSent"),
            text: t("ui.checkZimou"),
            confirmButtonText: t("ship.ok"),
            confirmButtonColor: "#7e5395",
            timer: 3000,
            timerProgressBar: true,
            position: "bottom-end",
            toast: true,
            showConfirmButton: false,
          });
        });
    } else if (status === "9") {
      const CiteMorooco = citeMorooco.find((d) => d.name === data.state);
      const formData = new FormData();
      formData.append("type", "SIMPLE");
      formData.append("business", store.AmeexId);
      formData.append("order_num", "ORDER_NUM_1");
      formData.append("replace", "true");
      formData.append("exchange_code", ""); // ضع الكود إذا عندك تبادل
      formData.append("open", "NO");
      formData.append("try", "YES");
      formData.append("fragile", "0");
      formData.append("receiver", data.name);
      formData.append("phone", data.phone);
      formData.append("city", CiteMorooco?.id);
      formData.append("address", adresse);
      formData.append("comment", data.note || "");
      formData.append("product", data.productName || "منتج من المتجر");
      formData.append("cod", parseInt(data.total));
      formData.append("products[0][id]", data.productId || ""); // UUID إذا متاح
      formData.append("products[0][qty]", "1");

      axios
        .post(
          "https://api.ameex.app/customer/Delivery/Parcels/Action/Type/Add",
          formData,
          {
            headers: {
              "C-Api-Id": `${store.AmeexId}`,
              "C-Api-Key": `${store.AmeexKey}`,
              "Content-Type": "multipart/form-data",
            },
          },
        )
        .then((response) => {
          const resApi = response.data?.api;

          if (resApi?.type === "success" && resApi?.data?.id) {
            const tracking = resApi.data.id;
            const trackingCode = resApi.data.code;

            // حفظ البيانات في Firestore
            setDoc(doc(db, "orders", data.id), {
              ...data,
              deleveryStatus: "4",
              tracking: tracking,
              trackingCode: trackingCode, // إن أردت تخزين الكود
              DC: status,
            });
          } else {
            // عرض تنبيه خطأ
            Swal.fire({
              icon: "error",
              title: t("ship.error"),
              text: t("ui.ameexNoTracking"),
              confirmButtonText: t("ship.ok"),
              confirmButtonColor: "#7e5395",
            });
          }
        })
        .catch((error) => {
          console.error(error.response?.data || error.message);
          Swal.fire({
            icon: "error",
            title: t("ui.sendOrderFailed"),
            text: t("ui.checkConnectionAccount"),
            confirmButtonText: t("ship.ok"),
            confirmButtonColor: "#7e5395",
          });
        });
    } else {
      const updatedOrder = { ...data, DC: status };
      await setDoc(doc(db, "orders", data.id), updatedOrder);
      // Mettre à jour le state local
      onStatusChange(data.id, updatedOrder);
    }
  };

  const orderTotal = (rowData) => {
    return (
      <>
        <span className="bg-[#faf1ff] dark:bg-[#3c3a3d] text-[#9e68ba] dark:text-[#e4b8e4] px-3 py-1 rounded-lg">
          {rowData.total} {localizedCurrency}
        </span>
      </>
    );
  };
  const orderPrice = (rowData) => {
    return (
      <>
        {rowData.total - rowData.deleveryPrice} {localizedCurrency}
      </>
    );
  };

  const customerName = (rowData) => {
    return (
      <Link
        style={{ color: "#1182ff", textDecoration: "none" }}
        to={`/orders/OrderDetailsabndn`}
        state={{
          from: {
            ...rowData,
          },
          product: productdata.filter(
            (product) => product.id === rowData.productId,
          )[0],
          products: productdata,
        }}
      >
        {rowData.name}
      </Link>
    );
  };

  const darkModeStyles = `
  /* Styles pour le mode sombre du DataTable */
  .dark .p-datatable .p-datatable-thead > tr > th {
    background-color: #1e1e1e !important;
    color: #d1d5db !important;
    border-color: #3c3a3d !important;
    border-top: 1px solid #3c3a3d !important;
    border-bottom: 1px solid #3c3a3d !important;
    border-left: 1px solid #1e1e1e !important;
    border-right: 1px solid #1e1e1e !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr {
    background-color: #181919 !important;
    color: #d1d5db !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr:nth-child(even) {
    background-color: #1e1e1e !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr:nth-child(odd) {
    background-color: #181919 !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr > td {
    border-color: #3c3a3d !important;
    // color: #d1d5db !important;
  }


  /* Pour les bordures du tableau */
  .dark .p-datatable {
    border-color: #3c3a3d !important;
  }

  /* Pour les éléments expandables */
  .dark .p-datatable .p-row-expansion {
    background-color: #141414 !important;
    color: #d1d5db !important;
  }
`;

  const statusOptions = {
    1: "جديد",
    3: "مؤكدة",
    9: "مؤكدة من قبل العميل",
    "11-2": "لم يرد على الاتصال",
    "11-3": "مؤجلة",
    6: "ملغي",
    "11-5": "ملغى من قبل العميل",
    "11-1": "انتظار اتصال العميل",
    "11-4": "الخط مغلق",
    4: "رفع لشركة التوصيل",
    5: "مكتملة",
  };
  const getStatusText = (status) => {
    return statusOptions[status] || "";
  };
  const formatTimestamp = (rowData) => {
    if (rowData.timestamp) {
      const date = rowData.timestamp.toDate();
      return date.toLocaleString(); // تنسيق الوقت والتاريخ حسب اللغة والتوقيت المحلي
    }
    return "";
  };

  // دالة لتقليل النص وإضافة النقاط الثلاث إذا كان أطول من الحد الأقصى
  const maxChars = 25;
  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    }
    return text;
  };

  const changeStatus = async (data, status) => {
    const currentTime = new Date();
    const updatedStatusTimeline = [
      ...(data.statusTimeline || []),
      { status, timestamp: currentTime },
    ];
    const telegramBotToken = "6672968395:AAHFokejZq4r6GRRDHlm2FDqXk0-pXoQmOs";
    const chatId = store.Idtelegram;
    const product = productdata.find(
      (product) => product.id === data.productId,
    );
    const truncatedProductName = truncateText(
      data.nameproduct ? data.nameproduct : product.name,
      maxChars,
    );
    const statusMessages = {};

    if (store.done === true) {
      statusMessages["5"] =
        `✅ تم إتمام الطلب بنجاح! ✅\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nنود إبلاغكم بأنه تم إتمام الطلب بنجاح. يمكنكم متابعة تفاصيل وضعية الطلب وموعد التسليم عبر البوابة الخاصة بكم. شكرًا لتفهمكم وثقتكم في خدماتنا.`;
    }
    const statusMessagess = {};

    if (store.termine === true) {
      statusMessagess["11-2"] =
        `📢 طلب لم يرد على الاتصال! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: 'لم يرد على الاتصال'. نقترح محاولة الاتصال مع العميل لاحقًا لتأكيد التفاصيل. شكرًا لك على تفانيك في تقديم خدمة عالية الجودة.`;
      statusMessagess["11-3"] =
        `📢 طلب مؤجل! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تأجيل تسليم الطلب إلى وقت لاحق. ننصح بجدولة الاتصال بالعميل لترتيب تفاصيل موعد التسليم المناسب. نقدر جهودك في تقديم الخدمة المميزة.`;
      statusMessagess["11-5"] =
        `📢 إلغاء طلب! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم إلغاء الطلب من قبل العميل. يُرجى ترتيب إجراءات الإلغاء ومتابعة الإجراءات المناسبة. نشكرك على تفهمك واهتمامك برضاء العملاء.`;
      statusMessagess["11-1"] =
        `📢 انتضار اتصال العميل ! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: 'انتظار اتصال العميل'. يُرجى محاولة التواصل مع العميل بأسرع وقت ممكن لتأكيد التفاصيل وترتيب التسليم المناسب. شكرًا لك على اهتمامك بتقديم الخدمة الفائقة.`;
      statusMessagess["11-4"] =
        `📢 طلب خط مغلق! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: 'الخط مغلق'. نود إبلاغك بأن العميل قد يكون غير متاح حاليًا. ننصح بمحاولة الاتصال في وقت لاحق أو ترتيب وقت مناسب للتواصل. نشكرك على جهودك في تقديم أفضل خدمة للعملاء.`;
    }

    const statusMessagees = {};

    if (store.confrim === true) {
      statusMessagees["3"] =
        `📢 طلب مؤكد! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: 'مؤكدة'. ننصح برفع الطلب في شركة التوصيل لبدء إجراءات التوصيل. شكرًا لك على جهودك في تقديم أفضل تجربة للعميل وتسهيل عملية التسليم.`;
    }
    if (store.confrim === true) {
      statusMessagees["9"] =
        `📢 طلب مؤكد من قبل العميل! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: 'مؤكدة'. ننصح برفع الطلب في شركة التوصيل لبدء إجراءات التوصيل. شكرًا لك على جهودك في تقديم أفضل تجربة للعميل وتسهيل عملية التسليم.`;
    }
    const statusMessageesNew = {};

    if (store.new === true) {
      statusMessageesNew["1"] =
        `📢 تحديث حالة الطلب! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nلدينا تحديث جديد على حالة الطلب. يُرجى تأكيد ومتابعة الحالة الجديدة في أقرب وقت ممكن. شكرًا لك على اهتمامك بتقديم خدمة مميزة وتلبية احتياجات العملاء بكل دقة وسرعة.`;
    }

    const statusMessagessDD = {};

    if (store.delevery === true) {
      statusMessagessDD["4"] =
        `🚚 طلب تم رفعه لشركة التوصيل! 🚚\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nنود إعلامك بأنه تم رفع الطلب لشركة التوصيل بنجاح. يتم الآن التنسيق لبدء عملية التسليم. نشكرك على جهودك واهتمامك بتقديم تجربة مميزة للعميل.`;
    }
    const statusMessagessCC = {};

    if (store.cancel === true) {
      statusMessagessDD["6"] =
        `❌ تم الغاء الطلب! ❌\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nنأسف لإبلاغكم بأن العميل قام بإلغاء الطلب. تم تحديث حالة الطلب بنجاح. شكرًا على جهودك في تقديم الخدمة ونأمل في تقديم تجربة أفضل في المستقبل.`;
    }
    const message =
      statusMessages[status] ||
      statusMessagees[status] ||
      statusMessagessCC[status] ||
      statusMessageesNew[status] ||
      statusMessagessDD[status] ||
      statusMessagess[status];
    const messageC = `📵 حالة الطلب غير مكتملة! 📵\n\n👤 العميل: ${data.name}\n📞 الهاتف: ********\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nنرجو إعلامك بأن رقم هاتف الطلب غير ظاهر بسبب عدم توفر رصيد كافي أو عدم تفعيل باقتك في فوورويب . يُرجى التحقق من حالة رصيدك وتفعيل الباقة لتتمكن من متابعة تفاصيل طلبك بشكل كامل. شكرًا على تفهمك ونتطلع لخدمتك بشكل أفضل.`;

    const updatedOrder = {
      ...data,
      deleveryStatus: status,
      statusTimeline: updatedStatusTimeline,
      firstDeleveryStatus: "20",
    };

    await setDoc(doc(db, "orders", data.id), updatedOrder);

    // Mettre à jour le state local du parent en temps réel
    onStatusChange(data.id, updatedOrder);

    {
      data.isValid
        ? axios
            .post(
              `https://api.telegram.org/bot${telegramBotToken}/sendMessage`,
              {
                chat_id: chatId,
                text: messageC,
              },
            )
            .then((response) => {
              console.log("تم إرسال الإشعار بنجاح");
            })
            .catch((error) => {
              console.error("حدث خطأ أثناء إرسال الإشعار", error);
            })
        : axios
            .post(
              `https://api.telegram.org/bot${telegramBotToken}/sendMessage`,
              {
                chat_id: chatId,
                text: message,
              },
            )
            .then((response) => {
              console.log("تم إرسال الإشعار بنجاح");
            })
            .catch((error) => {
              console.error("حدث خطأ أثناء إرسال الإشعار", error);
            });
    }
  };

  const changepaid = async (data, status) => {
    const updatedOrder = { ...data, paid: status };
    await setDoc(doc(db, "orders", data.id), updatedOrder);

    // Mettre à jour le state local
    onStatusChange(data.id, updatedOrder);
  };

  const rowExpansionTemplate = (data) => {
    const addIpToAdressipblock = async (data) => {
      Swal.fire({
        title: t("ship.confirm_block"),
        text: t("orderDetails.alerts.block.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "rgb(141, 93, 167)",
        cancelButtonColor: "#e87778",
        confirmButtonText: t("ship.confirm_block_button"),
        cancelButtonText: t("annule"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          const storeDocRef = doc(db, "store", store.id);

          if (data.ipAddress) {
            try {
              await updateDoc(storeDocRef, {
                Adressipblock: arrayUnion(data.ipAddress),
              });
              apicache(account, products);
              Swal.fire(
                t("ship.block_success"),
                ". تم حظر عنوان الايبي بنجاح",
                "success",
              );
            } catch (error) {
              console.error("Error adding الايبي: ", error);
              Swal.fire(
                t("ship.error"),
                ". حدث خطأ أثناء حظر عنوان الايبي",
                "error",
              );
            }
          } else {
            console.error("No الايبي address found in data");
            Swal.fire(
              t("ship.error"),
              ". لا يوجد عنوان الايبي في الطلب",
              "error",
            );
          }
        }
      });
    };
    const toggleSubmenu = (productId) => {
      setShowSubmenus((prevShowSubmenus) => ({
        ...prevShowSubmenus,
        [productId]: !prevShowSubmenus[productId],
      }));
    };
    const onDelete = async (product) => {
      try {
        const orderRef = doc(db, "orders", data.id); // استبدل "وثيقة_طلبك" بمعرف الوثيقة الفعلي
        await updateDoc(orderRef, {
          products: arrayRemove(product), // استخدم الكائن الكامل للحذف
        });
      } catch (e) {
        console.error("خطأ عند حذف المنتج: ", e);
      }
    };
    const removeIpFromAdressipblock = async (data) => {
      Swal.fire({
        title: t("ship.confirm_delete"),
        text: t("orderDetails.alerts.unblock.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "rgb(141, 93, 167)",
        cancelButtonColor: "#e87778",
        confirmButtonText: t("orderDetails.alerts.unblock.confirm"),
        cancelButtonText: t("annule"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          const storeDocRef = doc(db, "store", store.id);

          if (data.ipAddress) {
            try {
              await updateDoc(storeDocRef, {
                Adressipblock: arrayRemove(data.ipAddress),
              });
              Swal.fire(
                t("ship.delete_success"),
                ". تم حذف عنوان الايبي بنجاح",
                "success",
              );
            } catch (error) {
              console.error("Error removing الايبي: ", error);
              Swal.fire(
                t("ship.error"),
                ". حدث خطأ أثناء حذف عنوان الايبي",
                "error",
              );
            }
          } else {
            console.error("No الايبي address found in data");
            Swal.fire(
              t("ship.error"),
              ". لا يوجد عنوان الايبي في الطلب",
              "error",
            );
          }
        }
      });
    };
    const timestamp = data.timeStamp;
    const date = new Date(timestamp.seconds * 1000);
    const formattedDate = date.toLocaleString();
    const product = productdata.find(
      (product) => product.id === data.productId,
    );
    let productsToShow = [];
    if (data.products && data.products.length > 0) {
      productsToShow = data.products.map((p) =>
        productdata.find((product) => product.id === p.id),
      );
    }
    return (
      <div className="orders-subtable row">
        <div className="max-w-2xl mx-auto py-0 md:px-8">
          {data.nameproduct ? (
            <>
              {data.products ? (
                <ul>
                  <div className="max-w-2xl mx-auto py-0 md:px-8">
                    <div className="d-flex justify-content-between dark:!border-[#3c3a3d] w-100 p-1-2 border4">
                      <li className="flex gap-4 items-center">
                        <img
                          src={data.image ? data.image : "/product-foorweb.png"}
                          className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                        />
                        <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                          {data.nameproduct}
                        </div>
                        <span className="text-sm">
                          {data.total - data.deliveryPrice} {localizedCurrency}
                        </span>
                      </li>
                    </div>
                  </div>
                </ul>
              ) : (
                <ul>
                  <div className="max-w-2xl mx-auto py-0 md:px-8">
                    <div className="d-flex justify-content-between w-100 p-1-2 border4">
                      <li className="flex gap-4 items-center">
                        <img
                          src={data.image ? data.image : "/product-foorweb.png"}
                          className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                        />
                        <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                          {data.nameproduct}
                        </div>
                        <span className="text-sm">
                          {data.total - data.deliveryPrice} {localizedCurrency}
                        </span>
                      </li>
                    </div>
                  </div>
                </ul>
              )}
            </>
          ) : data.products ? (
            <ul>
              {data?.nameproduct
                ? productsToShow.map((product) => (
                    <div
                      className="max-w-2xl mx-auto py-0 md:px-8"
                      key={product?.id}
                    >
                      <div className="d-flex justify-content-between w-100 p-1-2 border4">
                        <li className="flex gap-4 items-center">
                          <img
                            src={
                              product?.image
                                ? product?.image
                                : "/product-foorweb.png"
                            }
                            className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                          />
                          <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                            {product?.name}
                          </div>
                          <span className="text-sm">
                            {product?.price} {localizedCurrency}
                          </span>
                        </li>
                      </div>
                    </div>
                  ))
                : data.products.map((product, index) => (
                    <div className="max-w-2xl mx-auto py-0 md:px-8">
                      <div className="d-flex justify-content-between w-100 p-1-2 border4">
                        <li className="flex gap-4 items-center">
                          <img
                            src={
                              product.image
                                ? product.image
                                : "/product-foorweb.png"
                            }
                            className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                          />
                          <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                            {product.name}
                          </div>
                          <span className="text-sm">
                            {data.total - data.deliveryPrice}{" "}
                            {localizedCurrency}
                          </span>
                        </li>
                      </div>
                    </div>
                  ))}
            </ul>
          ) : (
            <ul>
              <div className="d-flex justify-content-between w-100 p-1-2 border4">
                <li className="flex gap-4 items-center">
                  <img
                    src={product ? product.image : "/product-foorweb.png"}
                    className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                  />
                  <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                    {product ? product.name : ""}
                  </div>
                  <span className="text-sm">
                    {data.total} {localizedCurrency}
                  </span>
                </li>
              </div>
            </ul>
          )}
        </div>

        <div className="mt-2 dark:text-gray-300">
          <p className="text-gray-600 text-sm font-semibold sm:text-xs dark:text-gray-300">
            {t("orders.datatable_templating_demo.order_status_updates")}:
          </p>
          <div
            className="flex items-center"
            style={{ overflowX: "auto", whiteSpace: "nowrap" }}
          >
            {data.statusTimeline ? (
              data.statusTimeline.map((statusUpdate, idx, array) => {
                const isFirstItem = idx === 0;
                return (
                  <div
                    key={idx}
                    className={`flex items-center dark:text-gray-300 ${
                      !isFirstItem ? "ml-2" : ""
                    }`}
                  >
                    {!isFirstItem && (
                      <img
                        src="https://cdn-icons-png.flaticon.com/128/3575/3575967.png"
                        alt=""
                        className="w-4 h-4"
                        style={{ marginLeft: "5px", marginRight: "5px" }}
                      />
                    )}
                    <img
                      src={
                        statusUpdate.status === "1"
                          ? "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"
                          : statusUpdate.status === "2"
                            ? "https://cdn-icons-png.flaticon.com/128/1688/1688988.png"
                            : statusUpdate.status === "9"
                              ? "https://cdn-icons-png.flaticon.com/128/1688/1688988.png"
                              : statusUpdate.status === "3"
                                ? "https://cdn-icons-png.flaticon.com/128/6815/6815043.png"
                                : statusUpdate.status === "4"
                                  ? "https://cdn-icons-png.flaticon.com/128/1559/1559859.png"
                                  : statusUpdate.status === "5"
                                    ? "https://cdn-icons-png.flaticon.com/128/6815/6815043.png"
                                    : statusUpdate.status === "6"
                                      ? "https://cdn-icons-png.flaticon.com/128/391/391247.png"
                                      : statusUpdate.status === "11-1"
                                        ? "https://cdn-icons-png.flaticon.com/128/2593/2593514.png"
                                        : statusUpdate.status === "11-2"
                                          ? "https://cdn-icons-png.flaticon.com/128/9946/9946401.png"
                                          : statusUpdate.status === "11-3"
                                            ? "../agenda.png"
                                            : statusUpdate.status === "11-4"
                                              ? "https://cdn-icons-png.flaticon.com/128/8402/8402548.png"
                                              : statusUpdate.status === "11-5"
                                                ? "https://cdn-icons-png.flaticon.com/128/7787/7787073.png"
                                                : "https://cdn-icons-png.flaticon.com/128/11442/11442042.png"
                      }
                      className="w-10 h-10"
                      alt=""
                    />
                  </div>
                );
              })
            ) : (
              <p className="text-gray-700 text-center dark:text-gray-400 mx-auto">
                {t("orders.datatable_templating_demo.no_Update")}
              </p>
            )}
          </div>
        </div>
        <div>
          <h4 className=" font-semibold sm:text-lg dark:text-gray-300">
            {t("orders.datatable_templating_demo.receive_order")}
          </h4>
          <p className="text-[#9e68ba]">{formattedDate}</p>
        </div>
        <div className="mt-2 grid gap-8 sm:grid-cols-2 lg:grid-cols-2">
          <div className=" justify-content-between w-100 p-1-2 border4 dark:!border-[#3c3a3d]">
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.full_name")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>{data.name}</b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.phone_number")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>
                  {" "}
                  {data.isValid ? (
                    <i className="fs-3" onClick={() => handlePay(data)}>
                      <img src={"/lock.png"} className="mx-auto" alt="lock" />
                    </i>
                  ) : (
                    <a
                      href={`tel:${data.phone}`}
                      style={{ textDecoration: "none" }}
                    >
                      {data.phone}
                    </a>
                  )}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.full_address")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.state}.{data.commune}.{data.address}{" "}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.customer_note")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>
                  {data?.note?.trim() !== "" || data?.options?.trim() !== ""
                    ? data?.note?.trim() || data?.options?.trim()
                    : t("orders.datatable_templating_demo.no_note")}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.ip_address")} :
              </p>
              <p className="m-0 text-success">
                <b>{data.ipAddress ? data.ipAddress : "-"}</b>
              </p>
            </div>
          </div>

          <div className=" justify-content-between w-100 p-1-2 border4 dark:!border-[#3c3a3d]">
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.product_value")} :
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.total -
                    (data.deleveryPrice
                      ? data.deleveryPrice
                      : data.deliveryPrice)}{" "}
                  {localizedCurrency}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.quantity")} :
              </p>
              <p className="m-0 text-success">
                <b> {data.qty} </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.delivery_fees")} :
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.deleveryPrice ? data.deleveryPrice : data.deliveryPrice}{" "}
                  {localizedCurrency}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.grand_total")} :
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.total} {localizedCurrency}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => addIpToAdressipblock(data)}
              >
                {t("orders.datatable_templating_demo.block")}
              </button>
              <button
                type="button"
                className="btn btn-outline-warning"
                onClick={() => removeIpFromAdressipblock(data)}
              >
                {t("orders.datatable_templating_demo.delete")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleDelete = async (data) => {
    Swal.fire({
      title: t("ship.confirm_delete"),
      text: t("ship.delete_order_prompt"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(141, 93, 167)",
      cancelButtonColor: "#e87778",
      confirmButtonText: t("ship.yes"),
      cancelButtonText: t("ship.no"),
    }).then((result) => {
      if (result.isConfirmed) {
        const audio = new Audio("/Mouth woosh_42.wav");
        audio.play();

        const movedOrder = { ...data, deleveryStatus: "8" };
        setDoc(doc(db, "orders", data.id), movedOrder).then(() => {
          onStatusChange(data.id, movedOrder);
        });
      }
    });
  };

  const handleUpdate = async (rowData) => {
    if (typeof setData === "function") {
      setData(rowData);
    }
    if (typeof setLgShow === "function") {
      setLgShow(true);
    }
  };

  const generateFileName = () => {
    // الحصول على التاريخ والوقت الحالي
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // الشهر يبدأ من 0
    const day = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");

    // بناء اسم الملف مع التاريخ والوقت
    return `ordersfoorweb_${year}-${month}-${day}_${hours}:${minutes}.csv`;
  };
  const actionTemplate = (rowData) => {
    return (
      <Dropdown
        overlay={
          <Menu className=" right-to-left">
            {rowData.isValid === false &&
              typeof setData === "function" &&
              typeof setLgShow === "function" && (
                <Menu.Item
                  key="2"
                  className=" ms-33 ss hover:text-green-500"
                  size={16}
                  onClick={
                    !!account.store
                      ? () => handleUpdate(rowData)
                      : () => {
                          message();
                        }
                  }
                >
                  <i
                    style={{
                      display: "flex",
                      textAlign: "center",
                      paddingRight: "2px",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-file-pen-line hover:text-green-500 ml-2"
                    >
                      <path d="m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2" />
                      <path d="M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" />
                      <path d="M8 18h1" />
                    </svg>
                    {t("orders.datatable_templating_demo.edit")}
                  </i>
                </Menu.Item>
              )}
            <Menu.Item
              key="1"
              className=" ms-33 ss hover:text-green-500"
              size={16}
            >
              <Link
                to={`/orders/OrderDetailsabndn`}
                state={{
                  from: {
                    ...rowData,
                  },
                  product: productdata.filter(
                    (product) => product.id === rowData.productId,
                  )[0],
                  products: productdata,
                }}
              >
                {" "}
                <i
                  style={{
                    display: "flex",
                    textAlign: "center",
                    paddingRight: "2px",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-eye ml-2 hover:text-green-500"
                  >
                    <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                  {t("orders.datatable_templating_demo.preview")}
                </i>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="3"
              className=" ms-33 ss1 "
              size={16}
              onClick={
                !!account.store
                  ? () => {
                      handleDelete(rowData);
                    }
                  : () => {
                      message();
                    }
              }
            >
              <i
                style={{
                  color: "#f21919",
                  display: "flex",
                  textAlign: "center",
                  paddingRight: "2px",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#f21919"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  className="lucide lucide-trash2-icon lucide-trash-2 ml-2"
                >
                  <path d="M3 6h18" />
                  <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                  <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                  <line x1="10" x2="10" y1="11" y2="17" />
                  <line x1="14" x2="14" y1="11" y2="17" />
                </svg>
                {t("orders.datatable_templating_demo.delete")}
              </i>
            </Menu.Item>
          </Menu>
        }
      >
        <button className=" bot1">
          <img
            src={"/8675169.png"}
            style={{ width: "22px" }}
            alt={t("ui.buttonIcon")}
          />
        </button>
      </Dropdown>
    );
  };

  const groubeUpdates = async (data) => {
    // Get a new write batch
    const batch = writeBatch(db);
    const telegramBotToken = "6672968395:AAHFokejZq4r6GRRDHlm2FDqXk0-pXoQmOs";
    const chatId = store.Idtelegram;
    const allMessage = `📢 تم تغيير حالات طلباتك بشكل جماعي. تفقد متجرك للاطلاع على المستجدات وتحديثات الطلبات. 🛍️💼`;

    if (bluck === "7") {
      selectedProducts.forEach((order) => {
        const sfRef = doc(db, "orders", order.id);
        // تعيين حقل 'deleted' إلى '1' للطلب باستخدام batch.set
        batch.set(sfRef, { ...order, deleted: 1 });
        // Mettre à jour le state local
        onStatusChange(order.id, { ...order, deleted: 1 });
      });
    } else {
      selectedProducts.forEach((order) => {
        const sfRef = doc(db, "orders", order.id);
        // تحديث حقل 'deleveryStatus' بالقيمة المحددة في `bluck` باستخدام batch.update
        batch.update(sfRef, { deleveryStatus: bluck });
        // Mettre à jour le state local
        onStatusChange(order.id, { ...order, deleveryStatus: bluck });
      });
    }
    axios
      .post(`https://api.telegram.org/bot${telegramBotToken}/sendMessage`, {
        chat_id: chatId,
        text: allMessage,
      })
      .then((response) => {
        console.log("تم إرسال الإشعار بنجاح");
      })
      .catch((error) => {
        console.error("حدث خطأ أثناء إرسال الإشعار", error);
      });

    try {
      // Commit the batch
      await batch.commit();

      // التأكد من أن العملية تمت بنجاح وعرض رسالة Swal للمستخدم
      if (bluck === "7") {
        Swal.fire({
          title: t("ui.deletedSuccessfully"),
          icon: "success",
          confirmButtonText: t("ship.yes"),
          confirmButtonColor: "rgb(141, 93, 167)",
        });
      }
    } catch (error) {
      // إذا حدث خطأ أثناء الحذف أو التحديث بالجملة
      Swal.fire({
        title: t("foorAi.history.error.generic"),
        text: t("FormSettings.alerts.save_error.text"),
        icon: "error",
      });
    }
  };

  const selectTemplate = (rowData) => {
    return (
      <div>
        <Form.Check
          type={"checkbox"}
          checked={selectedProducts.map((p) => p.id).includes(rowData.id)}
          onChange={() => {
            !selectedProducts.map((p) => p.id).includes(rowData.id)
              ? setSelectedProducts([...selectedProducts, rowData])
              : setSelectedProducts(
                  selectedProducts.filter((p) => p.id !== rowData.id),
                );
          }}
        />
      </div>
    );
  };

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handlePay = async (rowData) => {
    const orderId = rowData?.id;
    if (!orderId || unlockingOrderIds[orderId]) {
      return;
    }
    setUnlockingOrderIds((prev) => ({ ...prev, [orderId]: true }));

    const isOnline = navigator.onLine;

    if (!isOnline) {
      // رسالة عندما لا يكون هناك اتصال بالإنترنت
      Swal.fire({
        icon: "error",
        title: t("ship.no_internet"),
        text: t("orderDetails.alerts.internet.text"),
        confirmButtonText: t("orders.datatable_templating_demo.okay"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      setUnlockingOrderIds((prev) => ({ ...prev, [orderId]: false }));
      return;
    }

    try {
      // dhd: unlock for free (no token)
      if (!isDhdUser) {
        const nextAccount = await consumeSubscriptionToken({
          accountId: account?.id,
        });
        dispatch(fetchAccount(nextAccount));
      }

      await updateDoc(doc(db, "orders", rowData.id), {
        isValid: false,
      });

      dispatch(
        fetchOrders(
          ordersState.map((order) =>
            order.id === rowData?.id ? { ...order, isValid: false } : order,
          ),
        ),
      );
    } catch (error) {
      console.error("Error while processing payment:", error);

      if (error?.code === "INSUFFICIENT_TOKENS") {
        const result = await Swal.fire({
          icon: "error",
          title: t("ship.insufficient_balance"),
          text: t("ship.insufficient_balance_message"),
          confirmButtonText: t("ship.recharge_balance"),
          confirmButtonColor: "rgb(141, 93, 167)",
          showCancelButton: true,
          cancelButtonText: t("annule"),
          cancelButtonColor: "#e87778",
        });
        if (result.isConfirmed) window.location.href = "/plan";
      } else {
        Swal.fire({
          icon: "error",
          title: t("orders.datatable_templating_demo.error"),
          text: t("ui.paymentProcessingError"),
          confirmButtonText: t("orders.datatable_templating_demo.okay"),
          confirmButtonColor: "rgb(141, 93, 167)",
        });
      }
    } finally {
      setUnlockingOrderIds((prev) => ({ ...prev, [orderId]: false }));
    }
  };

  const notPaidTemplate = (rowData) => {
    const currentData = ordersState.find((o) => o.id === rowData.id) || rowData;
    const isUnlocking = !!unlockingOrderIds[currentData.id];

    const handleCopyPhone = async (phone, event) => {
      const showSuccessNotification = (targetElement) => {
        const rect = targetElement.getBoundingClientRect();

        const successMsg = document.createElement("div");
        successMsg.innerHTML = "✅ تم النسخ بنجاح!";
        successMsg.style.cssText = `
        position: fixed;
        top: ${rect.bottom + 10}px;
        left: ${rect.left + rect.width / 2}px;
        transform: translateX(-50%);
        background: linear-gradient(135deg, #4CAF50, #45a049);
        color: white;
        padding: 12px 20px;
        border-radius: 25px;
        font-size: 14px;
        font-weight: bold;
        z-index: 50;
        direction: rtl;
        font-family: Arial, sans-serif;
        box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4);
        border: 2px solid rgba(255, 255, 255, 0.3);
        animation: copySuccess 0.6s ease-out;
        white-space: nowrap;
      `;

        if (!document.getElementById("copy-success-animation")) {
          const style = document.createElement("style");
          style.id = "copy-success-animation";
          style.textContent = `
          @keyframes copySuccess {
            0% {
              opacity: 0;
              transform: translateX(-50%) translateY(-10px) scale(0.8);
            }
            50% {
              opacity: 1;
              transform: translateX(-50%) translateY(0) scale(1.05);
            }
            100% {
              opacity: 1;
              transform: translateX(-50%) translateY(0) scale(1);
            }
          }
          @keyframes copyFadeOut {
            0% {
              opacity: 1;
              transform: translateX(-50%) translateY(0) scale(1);
            }
            100% {
              opacity: 0;
              transform: translateX(-50%) translateY(-10px) scale(0.9);
            }
          }
        `;
          document.head.appendChild(style);
        }

        document.body.appendChild(successMsg);

        setTimeout(() => {
          successMsg.style.animation = "copyFadeOut 0.3s ease-in forwards";
          setTimeout(() => {
            if (document.body.contains(successMsg)) {
              document.body.removeChild(successMsg);
            }
          }, 300);
        }, 1700);
      };

      try {
        await navigator.clipboard.writeText(phone);
        showSuccessNotification(event.target);
      } catch (err) {
        console.error("Failed to copy: ", err);
        const textArea = document.createElement("textarea");
        textArea.value = phone;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        showSuccessNotification(event.target);
      }
    };

    return (
      <div>
        {isFreeCountry || !currentData.isValid ? (
          <span
            style={{
              textDecoration: "none",
              color: "#007bff",
              cursor: "pointer",
            }}
            onClick={(e) => handleCopyPhone(currentData.phone, e)}
            title={t("ship.click_to_copy")} // Arabic tooltip: 'Click to copy'
          >
            {currentData.phone}
          </span>
        ) : (
          <i
            className={`fs-3 ${isUnlocking ? "opacity-50 pointer-events-none" : ""}`}
            onClick={() => handlePay(currentData)}
          >
            <img src={"/lock.png"} className="mx-auto" />
          </i>
        )}
      </div>
    );
  };
  const wilaya1 = (rowData) => {
    return (
      <div>
        {
          <a style={{ color: "#1182ff", textDecoration: "none" }}>
            {rowData.state}
          </a>
        }
      </div>
    );
  };
  const imageBodyTemplate = (rowData) => {
    let productsToShow = [];
    const product = productdata.find(
      (product) => product.id === rowData.productId,
    );
    if (rowData.products && rowData.products.length > 0) {
      productsToShow = rowData.products
        .filter((_, index) => index === 0 || index === 1)
        .map((p) => productdata.find((product) => product.id === p.id));
    }

    return rowData.products ? (
      <Link
        to={`/orders/OrderDetailsabndn`}
        state={{
          from: { ...rowData },
          product: productdata.find(
            (product) => product.id === rowData.productId,
          ),
          products: productsToShow,
        }}
      >
        <div className="flex -space-x-2 overflow-hidden">
          {rowData.products ? (
            rowData.products.map((product) => (
              <div className="flex -space-x-2 overflow-hidden">
                <div className="relative">
                  <img
                    src={product.image ? product.image : "/product-foorweb.png"}
                    height="75px"
                    alt={product.name ? product.name : ""}
                    className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff] avatar2"
                  />
                </div>
              </div>
            ))
          ) : (
            <div className="max-w-2xl mx-auto py-0 md:px-8">
              <div className="flex -space-x-2 overflow-hidden">
                <div className="relative">
                  <img
                    src={rowData.image ? rowData.image : "/product-foorweb.png"}
                    height="75px"
                    alt={rowData.nameproduct ? rowData.nameproduct : ""}
                    className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff] avatar2"
                  />
                </div>
              </div>
            </div>
          )}

          {rowData.products.length > 2 ? (
            <div className="relative">
              <div className="absolute top-0 left-0 bg-red-500 text-white w-5 h-5 flex items-center justify-center rounded-full">
                {rowData.products.length > 2
                  ? `${rowData.products.length - 2}+`
                  : ""}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </Link>
    ) : (
      <>
        {rowData.nameproduct ? (
          <Link
            to={`/orders/OrderDetailsabndn`}
            state={{
              from: { ...rowData },
            }}
          >
            <div className="flex -space-x-2 overflow-hidden">
              <div className="relative">
                <img
                  src={rowData.image ? rowData.image : "/product-foorweb.png"}
                  height="75px"
                  alt={rowData.nameproduct ? rowData.nameproduct : ""}
                  className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff] avatar2"
                />
              </div>
            </div>
          </Link>
        ) : (
          <Link
            to={`/orders/OrderDetailsabndn`}
            state={{
              from: { ...rowData },
              product: productdata.filter(
                (product) => product.id === rowData.productId,
              )[0],
              products: productdata,
            }}
          >
            <div className="flex -space-x-2 overflow-hidden">
              <div className="relative">
                <img
                  src={product ? product.image : "/product-foorweb.png"}
                  height="75px"
                  alt={product ? product.name : ""}
                  className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff] avatar2"
                />
              </div>
            </div>
          </Link>
        )}
      </>
    );
  };
  const [showOptions, setShowOptions] = useState(false);
  const handleButtonClick = () => {
    setShowOptions(!showOptions); // تغيير حالة الإظهار عند النقر
  };
  /*--------------------------------------- زر الحالات -----------------------------------------------*/
  const combinedTemplate = (rowData) => {
    const statusColor = statusBodyTemplate(rowData);
    let text = null;
    let buttonImage =
      "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"; // الصورة الافتراضية

    if (rowData.deleveryStatus === "1") {
      buttonImage = "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";
    } else if (rowData.deleveryStatus === "2") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/1688/1688988.png";
    } else if (rowData.deleveryStatus === "9") {
      buttonImage = "/8888205.png";
    } else if (rowData.deleveryStatus === "3") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/8888/8888205.png";
    } else if (rowData.deleveryStatus === "4") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/1559/1559859.png";
    } else if (rowData.deleveryStatus === "5") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/6815/6815043.png";
    } else if (
      rowData.deleveryStatus === "6" ||
      rowData.deleveryStatus === "6-3"
    ) {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/391/391247.png";
    } else if (rowData.deleveryStatus === "6-1") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/595/595067.png";
    } else if (rowData.deleveryStatus === "6-2") {
      buttonImage = "./order6-2.png";
    } else if (rowData.deleveryStatus === "11-1") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/2593/2593514.png";
    } else if (rowData.deleveryStatus === "11-2") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/9946/9946401.png";
      // إذا تم اختيار إرسال إلى شركة الشحن
      if (rowData.DC === "1") {
        buttonImage = "https://cdn-icons-png.flaticon.com/128/9946/9946401.png";
      }
    } else if (rowData.deleveryStatus === "11-3") {
      buttonImage = "../agenda.png";
    } else if (rowData.deleveryStatus === "11-4") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/8402/8402548.png";
    } else if (rowData.deleveryStatus === "11-5") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/7787/7787073.png";
    } else if (rowData.deleveryStatus === "10") {
      buttonImage = "https://cdn-icons-png.flaticon.com/512/11153/11153363.png";
    }

    const shippingOptions = [];
    if (!!store.Maystro) shippingOptions.push({ value: "1", label: "Maystro" });
    if (!!store.Zrexpress)
      shippingOptions.push({ value: "2", label: "Zr express" });
    if (!!store.Ecotrack && !!store.Uecotrack)
      shippingOptions.push({ value: "3", label: "Ecotrack" });
    if (!!store.Userguid && !!store.ApitokenNord)
      shippingOptions.push({ value: "4", label: "Nord Et Ouest" });
    if (!!store.YalidineW && !!store.Yalidinetoken && !!store.Yalidineid)
      shippingOptions.push({ value: "5", label: "Yalidine" });
    if (!!store.UserguidGuepex && !!store.Apitokenguepex)
      shippingOptions.push({ value: "6", label: "Guepex" });
    if (!!store.apielogistia)
      shippingOptions.push({ value: "7", label: "elogistia" });
    if (!!store.zimouToken)
      shippingOptions.push({ value: "8", label: "zimou Express" });
    if (!!store.AmeexId) shippingOptions.push({ value: "9", label: "Ameex" });
    if (!!store.mdm_apikey)
      shippingOptions.push({ value: "10", label: "MDM Express" });
    if (!!store.YalitecId)
      shippingOptions.push({ value: "11", label: "Yalitec" });
    if (!!store.coliv_token)
      shippingOptions.push({ value: "12", label: "Colvraison" });
    if (!!store.mylerzToken)
      shippingOptions.push({ value: "13", label: "Mylerz" });
    // if (!!store.Zrexpress) shippingOptions.push({ value: "8", label: "3Mexpress" });

    if (isDhdUser) {
      // dhd users can only send to ecotrack
      const ecotrackOnly = shippingOptions.filter((opt) => opt.value === "3");
      shippingOptions.length = 0;
      shippingOptions.push(...ecotrackOnly);
    }

    return (
      <Dropdown
        overlay={
          <Menu className="dark:bg-[#141414] dark:!text-gray-300 dark:!border-[#3c3a3d]">
            {rowData.isValid && (
              <Menu.Item className="rtl:text-right ltr:text-left ss1 bi bi-lock-fill dark:!text-gray-300">
                <a className="s11 dark:!text-gray-300">{t("ui.unlock")}</a>
              </Menu.Item>
            )}
            {!rowData.isValid && (
              <>
                {rowData.deleveryStatus !== "5" && (
                  <>
                    <Menu.Item
                      key="3"
                      className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-cart-check dark:!text-gray-300  ${
                        rowData.deleveryStatus === "3" ? "selected" : ""
                      }`}
                      onClick={() => changeStatus(rowData, "3")}
                    >
                      <a className="s11 dark:!text-gray-300">
                        {t("orders.datatable_templating_demo.confirmed")}
                      </a>
                    </Menu.Item>
                    <hr className="m-0 p-0" />
                    {store.confirmChat && (
                      <Menu.Item
                        key="9"
                        className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-cart-check dark:!text-gray-300 ${
                          rowData.deleveryStatus === "9" ? "selected" : ""
                        }`}
                        onClick={() => changeStatus(rowData, "9")}
                      >
                        <a className="s11 dark:!text-gray-300">
                          {t(
                            "orders.datatable_templating_demo.confirmed_by_customer",
                          )}
                        </a>
                      </Menu.Item>
                    )}
                    {store.confirmChat && <hr className="m-0 p-0" />}
                    <Menu.Item
                      key="11-2"
                      className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-telephone-x-fill dark:!text-gray-300 ${
                        rowData.deleveryStatus === "11-2" ? "selected" : ""
                      }`}
                      onClick={() => changeStatus(rowData, "11-2")}
                    >
                      <a className="s11 dark:!text-gray-300">
                        {t(
                          "orders.datatable_templating_demo.no_response_to_call",
                        )}
                      </a>
                    </Menu.Item>
                    <hr className="m-0 p-0" />
                    <Menu.Item
                      key="11-3"
                      className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-calendar2-check dark:!text-gray-300${
                        rowData.deleveryStatus === "11-3" ? "selected" : ""
                      }`}
                      onClick={() => changeStatus(rowData, "11-3")}
                    >
                      <a className="s11 dark:!text-gray-300">
                        {t("orders.datatable_templating_demo.postponed")}
                      </a>
                    </Menu.Item>

                    <hr className="m-0 p-0" />
                    <Menu.Item
                      key="6"
                      className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-x-circle dark:!text-gray-300 ${
                        rowData.deleveryStatus === "6" ? "selected" : ""
                      }`}
                      onClick={() => changeStatus(rowData, "6")}
                    >
                      <a className="s11 dark:!text-gray-300">
                        {t("orders.datatable_templating_demo.cancelled")}
                      </a>
                    </Menu.Item>
                    <hr className="m-0 p-0" />

                    <Menu.Item
                      key="6-1"
                      className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-exclamation-circle dark:!text-gray-300 ${
                        rowData.deleveryStatus === "6-1" ? "selected" : ""
                      }`}
                      onClick={() => changeStatus(rowData, "6-1")}
                    >
                      <a className="s11 dark:!text-gray-300">
                        {t("orders.datatable_templating_demo.fake")}
                      </a>
                    </Menu.Item>
                    <hr className="m-0 p-0" />

                    <Menu.Item
                      key="6-2"
                      className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-files dark:!text-gray-300 ${
                        rowData.deleveryStatus === "6-2" ? "selected" : ""
                      }`}
                      onClick={() => changeStatus(rowData, "6-2")}
                    >
                      <a className="s11 dark:!text-gray-300">
                        {t("orders.datatable_templating_demo.duplicate")}
                      </a>
                    </Menu.Item>
                    <hr className="m-0 p-0" />

                    <Menu.Item
                      key="11-5"
                      className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-person-x dark:!text-gray-300 ${
                        rowData.deleveryStatus === "11-5" ? "selected" : ""
                      }`}
                      onClick={() => changeStatus(rowData, "11-5")}
                    >
                      <a className="s11 dark:!text-gray-300">
                        {t(
                          "orders.datatable_templating_demo.cancelled_by_customer",
                        )}
                      </a>
                    </Menu.Item>
                    <hr className="m-0 p-0" />
                    <Menu.Item
                      key="11-1"
                      className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-telephone-inbound dark:!text-gray-300 ${
                        rowData.deleveryStatus === "11-1" ? "selected" : ""
                      }`}
                      onClick={() => changeStatus(rowData, "11-1")}
                    >
                      <a className="s11 dark:!text-gray-300">
                        {t(
                          "orders.datatable_templating_demo.awaiting_customer_contact",
                        )}
                      </a>
                    </Menu.Item>
                    <hr className="m-0 p-0" />
                    <Menu.Item
                      key="11-4"
                      className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-telephone-minus dark:!text-gray-300 ${
                        rowData.deleveryStatus === "11-4" ? "selected" : ""
                      }`}
                      onClick={() => changeStatus(rowData, "11-4")}
                    >
                      <a className="s11 dark:!text-gray-300">
                        {t("orders.datatable_templating_demo.line_busy")}
                      </a>
                    </Menu.Item>
                    <hr className="m-0 p-0" />
                    <Menu.Item
                      key="4"
                      className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-truck dark:!text-gray-300 ${
                        rowData.deleveryStatus === "4" ? "selected" : ""
                      }`}
                      onClick={() => changeStatus(rowData, "4")}
                    >
                      <a className="s11 dark:!text-gray-300">
                        {t(
                          "orders.datatable_templating_demo.with_delivery_company",
                        )}
                      </a>
                    </Menu.Item>
                    <hr className="m-0 p-0" />

                    <Menu.Item
                      key="4"
                      className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-arrow-return-right dark:!text-gray-300 ${
                        rowData.deleveryStatus === "10" ? "selected" : ""
                      }`}
                      onClick={() => changeStatus(rowData, "10")}
                    >
                      <a className="s11 dark:!text-gray-300">
                        {t("orders.datatable_templating_demo.returned")}
                      </a>
                    </Menu.Item>
                    <hr className="m-0 p-0" />
                    {/* إضافة باقي العناصر هنا */}
                  </>
                )}
                <Menu.Item
                  key="5"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-check-circle dark:!text-gray-300 ${
                    rowData.deleveryStatus === "5" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "5")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.completed")}
                  </a>
                </Menu.Item>

                {isDhdUser && shippingOptions.length === 0 ? (
                  <Menu.Item
                    disabled
                    className="rtl:text-right ltr:text-left dark:!text-gray-300"
                  >
                    <span className="text-amber-600 text-sm">
                      {t(
                        "orders.datatable_templating_demo.activate_ecotrack_first",
                      )}
                    </span>
                  </Menu.Item>
                ) : (
                  !rowData.isValid &&
                  shippingOptions.length > 0 && (
                    <>
                      <hr className="m-0 p-0" />
                      {shippingOptions.map((option) => (
                        <Menu.Item
                          key={option.value}
                          className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-truck dark:!text-gray-300 ${
                            rowData.DC === option.value ? "selected" : ""
                          }`}
                          onClick={() => {
                            changeShip(rowData, option.value);
                          }}
                        >
                          <a className="s11 dark:!text-gray-300">
                            {t(
                              "orders.datatable_templating_demo.upload_to_delivery_company",
                            )}{" "}
                            {option.label}
                          </a>
                        </Menu.Item>
                      ))}
                    </>
                  )
                )}
              </>
            )}
          </Menu>
        }
      >
        <div className="relative inline-block dark:!bg-[#181919]">
          <button className="flex items-center dark:!bg-[#181919] justify-center px-4 py-2.5 rounded-lg border border-gray-300 dark:!border-[#3c3a3d] bg-white hover:bg-gray-100 active:bg-gray-200 transition duration-150 mx-auto">
            {text == null ? (
              <img
                src={buttonImage}
                alt={t("ui.buttonIcon")}
                style={{ width: "20px" }}
              />
            ) : (
              <span className="text-sm font-medium text-gray-800">{text}</span>
            )}
          </button>
        </div>
      </Dropdown>
    );
  };
  /*------------------------------------------------------------------------------------------------*/
  return (
    <div className="datatable-templating-demo">
      {/* Updated styling while preserving original variables and functions */}
      <div className="bg-white dark:!bg-[#181919] rounded-t-xl p-4 dark:!border-[#3c3a3d] border-y border-purple-100">
        <div className="flex flex-wrap items-center gap-3">
          {/* Selected Orders Label - Preserving original content but with new styling */}
          <div className="flex items-center">
            <span className="text-sm font-medium text-gray-700 ml-2 dark:text-gray-300">
              {t("orders.datatable_templating_demo.selected_orders")}:
            </span>
            <span className="bg-[#faf1ff] dark:bg-[#181919] text-[#9e68ba] px-2 py-0.5 rounded-md font-medium text-sm">
              {selectedProducts.length}
            </span>
          </div>

          {/* CSV Export Button - Preserving original functionality but with new styling */}
          <button
            disabled={selectedProducts.length < 1 || isDhdUser}
            className={`p-2 bg-white dark:!bg-[#141414] border ${
              selectedProducts.length < 1
                ? "border-gray-200 dark:!border-[#3c3a3d] opacity-50 cursor-not-allowed"
                : "border-purple-200 dark:!border-[#3c3a3d] hover:bg-purple-50"
            } rounded-lg transition-colors flex items-center gap-2`}
          >
            <CSVLink
              data={selectedProducts.map((p) => {
                // نفس المنطق السابق
                const productOptions =
                  p.products && p.products[0] && p.products[0].options;

                return {
                  index: p.index,
                  name: p.name,
                  phone: p.isValid ? "***" : p.phone,
                  state: p.state,
                  commune: p.commune,
                  address: p.address,
                  product: p.nameproduct || "منتج غير موجود",
                  qty: p.qty,
                  deleveryPrice: p.deleveryPrice,
                  total: p.total,
                  sku: p.sku,
                  // استخراج الـ options (size, color, offer)
                  options: productOptions
                    ? `Size: ${
                        productOptions.size ||
                        t("orders.datatable_templating_demo.undefined")
                      }, Color: ${
                        productOptions.color ||
                        t("orders.datatable_templating_demo.undefined")
                      }, Offer: ${
                        productOptions.offer ||
                        t("orders.datatable_templating_demo.undefined")
                      }`
                    : "لا توجد خيارات", // إذا لم يكن هناك options
                };
              })}
              filename={generateFileName()} // تحديد اسم الملف مع التاريخ والوقت
              className={
                selectedProducts.length < 1 || isDhdUser
                  ? "pointer-events-none"
                  : ""
              }
            >
              <div className="flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={`${
                    selectedProducts.length < 1 || isDhdUser
                      ? "text-gray-400"
                      : "text-[#9e68ba]"
                  }`}
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                <span
                  className={`${
                    selectedProducts.length < 1 || isDhdUser
                      ? "text-gray-400"
                      : "text-[#9e68ba]"
                  } text-sm font-medium`}
                >
                  {t("orders.datatable_templating_demo.export")}
                </span>
              </div>
            </CSVLink>
          </button>

          {/* Print Button - Preserving original functionality but with new styling */}
          {isDhdUser ? (
            <div className="relative group">
              <button
                type="button"
                disabled={!canPrintDhd || isPrintingBordereaux}
                onClick={handlePrintDhdBordereaux}
                className={`p-2 bg-white dark:!bg-[#141414] border rounded-lg transition-colors flex items-center gap-2 ${
                  !canPrintDhd || isPrintingBordereaux
                    ? "border-gray-200 dark:!border-[#3c3a3d] opacity-50 cursor-not-allowed"
                    : "border-purple-200 dark:!border-[#3c3a3d] hover:bg-purple-50"
                }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={
                    !canPrintDhd || isPrintingBordereaux
                      ? "text-gray-400"
                      : "text-[#9e68ba]"
                  }
                >
                  <polyline points="6 9 6 2 18 2 18 9" />
                  <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                  <rect x="6" y="14" width="12" height="8" />
                </svg>
                <span
                  className={`text-sm font-medium ${
                    !canPrintDhd || isPrintingBordereaux
                      ? "text-gray-400"
                      : "text-[#9e68ba]"
                  }`}
                >
                  {isPrintingBordereaux
                    ? "..."
                    : t("orders.datatable_templating_demo.print")}
                </span>
              </button>

              {!canPrintDhd && selectedProducts.length > 0 && (
                <div
                  className="pointer-events-none absolute top-full left-1/2 -translate-x-1/2 mt-2 hidden group-hover:block z-50 w-56 rounded-lg bg-gray-900 text-white text-xs px-3 py-2 shadow-lg text-center"
                  role="tooltip"
                >
                  {t("orders.datatable_templating_demo.print_dhd_only_hint")}
                </div>
              )}
            </div>
          ) : (
            <button
              disabled={selectedProducts.length < 1}
              onClick={handlePrint}
              className={`p-2 bg-white dark:!bg-[#141414] border ${
                selectedProducts.length < 1
                  ? "border-gray-200 opacity-50 cursor-not-allowed dark:!border-[#3c3a3d]"
                  : "border-purple-200 hover:bg-purple-50 dark:!border-[#3c3a3d]"
              } rounded-lg transition-colors flex items-center gap-2`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={
                  selectedProducts.length < 1
                    ? "text-gray-400"
                    : "text-[#9e68ba]"
                }
              >
                <polyline points="6 9 6 2 18 2 18 9" />
                <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                <rect x="6" y="14" width="12" height="8" />
              </svg>
              <span
                className={`${
                  selectedProducts.length < 1
                    ? "text-gray-400"
                    : "text-[#9e68ba]"
                } text-sm font-medium`}
              >
                {t("orders.datatable_templating_demo.print")}
              </span>
            </button>
          )}

          {!isDhdUser && store?.sheetabndn && (
            <GoogleSheetButtons
              selectedProducts={selectedProducts}
              t={t}
              store={store}
              showOnlyV3={true}
              sheetConfigKey="sheetabndn"
              buttonName={store?.sheetabndn[0]?.googleSheetName || ""}
              onSuccess={(ids) =>
                setSentToSheet((prev) => new Set([...prev, ...ids]))
              }
            />
          )}

          {/* Order Status Dropdown - Preserving original functionality but with new styling */}
          <select
            disabled={selectedProducts.length < 1}
            style={{ height: "34px" }}
            className={`p-2 bg-white border dark:!bg-[#141414] ${
              selectedProducts.length < 1
                ? "border-gray-200 opacity-50 cursor-not-allowed dark:!border-[#3c3a3d] "
                : "border-purple-200 hover:bg-purple-50 dark:!border-[#3c3a3d] dark:text-gray-300"
            } rounded-lg text-sm ${
              selectedProducts.length < 1 ? "text-gray-400" : "text-gray-700 "
            } focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent`}
            required
            placeholder={t("foorchat.stats.paymentMethod")}
            value={bluck}
            onChange={(e) => setBluck(e.target.value)}
          >
            <option value="">
              {t("orders.datatable_templating_demo.change_order_status")}
            </option>
            <option value="3">
              {t("orders.datatable_templating_demo.confirmed")}
            </option>
            <option value="11-2">
              {t("orders.datatable_templating_demo.no_response_to_call")}
            </option>
            <option value="11-3">
              {t("orders.datatable_templating_demo.postponed")}
            </option>
            <option value="6">
              {t("orders.datatable_templating_demo.cancelled")}
            </option>
            <option value="6-1">
              {t("orders.datatable_templating_demo.fake")}
            </option>
            <option value="6-2">
              {t("orders.datatable_templating_demo.duplicate")}
            </option>
            <option value="11-5">
              {t("orders.datatable_templating_demo.cancelled_by_customer")}
            </option>
            <option value="11-6">
              {t("orders.datatable_templating_demo.awaiting_customer_contact")}
            </option>
            <option value="11-4">
              {t("orders.datatable_templating_demo.line_busy")}
            </option>
            <option value="4">
              {t("orders.datatable_templating_demo.with_delivery_company")}
            </option>
            <option value="5">
              {t("orders.datatable_templating_demo.completed")}
            </option>
            <option value="7">
              {t("orders.datatable_templating_demo.delete")}
            </option>
          </select>

          {/* Apply Button - Preserving original functionality but with new styling */}
          <Button
            disabled={selectedProducts.length < 1 || bluck === ""}
            onClick={groubeUpdates}
            className={`py-2 px-4 rounded-lg text-sm font-medium dark:!bg-[#141414] border dark:!border-[#3c3a3d] ${
              selectedProducts.length < 1 || bluck === ""
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-[#9b59bf] hover:bg-[#814a9f] dark:!text-[#9e68ba] text-white"
            } transition-colors`}
          >
            {t("orders.datatable_templating_demo.process_action")}
          </Button>
        </div>
      </div>
      <div
        className={isDhdUser ? "select-none" : ""}
        onCopy={isDhdUser ? (e) => e.preventDefault() : undefined}
        onCut={isDhdUser ? (e) => e.preventDefault() : undefined}
        onContextMenu={isDhdUser ? (e) => e.preventDefault() : undefined}
        style={
          isDhdUser
            ? { userSelect: "none", WebkitUserSelect: "none" }
            : undefined
        }
      >
        <style>{darkModeStyles}</style>
        <DataTable
          value={
            !!filter
              ? orders.filter(
                  (order) =>
                    order.index
                      .toString()
                      .toLowerCase()
                      .includes(filter.toLowerCase()) ||
                    order.name.toLowerCase().includes(filter.toLowerCase()) ||
                    order.phone.toLowerCase().includes(filter.toLowerCase()) ||
                    order.orderCount
                      .toString()
                      .toLowerCase()
                      .includes(filter.toLowerCase()),
                )
              : _DATA.currentData()
          }
          responsiveLayout="scroll"
          rowExpansionTemplate={rowExpansionTemplate}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          emptyMessage={t("ship.no_results_found")}
          rowClassName={(rowData, rowIndex) =>
            rowIndex % 2 === 0
              ? "p-row-odd dark:!bg-[#1e1e1e]"
              : "p-row-even dark:!bg-[#181919]"
          }
          className="dark:!bg-[#181919] dark:text-gray-300"
        >
          <Column
            header={
              <Form.Check
                type={"checkbox"}
                checked={selectedProducts.length === _DATA.currentData().length}
                onChange={() => {
                  selectedProducts.length === _DATA.currentData().length
                    ? setSelectedProducts([])
                    : setSelectedProducts([..._DATA.currentData()]);
                }}
                className="dark:bg-gray-700 dark:!border-[#3c3a3d]"
              />
            }
            className="text-end dark:!bg-[#181919] dark:!text-gray-300"
            body={selectTemplate}
            style={{ width: "3rem" }}
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
          ></Column>
          <Column
            header={t("orders.datatable_templating_demo.product")}
            className="text-end"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            body={imageBodyTemplate}
          ></Column>
          <Column
            body={customerName}
            field="name"
            className="text-end n-name"
            header={t("orders.datatable_templating_demo.customer")}
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
          ></Column>
          <Column
            field={notPaidTemplate}
            className="text-end n-phone"
            header={t("orders.datatable_templating_demo.phone_number")}
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
          ></Column>
          {orders.some((order) => order.orderCount !== undefined) && (
            <Column
              field="orderCount"
              header={t("orders.datatable_templating_demo.repitition")}
              headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
              bodyClassName="text-center"
              body={(rowData) => (
                <div
                  className="flex items-center justify-center mx-auto bg-red-600 rounded-full w-6 h-6 text-white text-center relative cursor-pointer"
                  data-tooltip-id={`tooltip-${rowData.id}`}
                >
                  {rowData.orderCount}
                  <Tooltip id={`tooltip-${rowData.id}`} place="top">
                    <p className="text-white">{t("ui.timesLabel")}</p>
                    <ul className="p-2  text-white rounded-md shadow-lg">
                      {rowData.IdOrdersperDay?.map((order, index) => (
                        <li key={index}>
                          {new Date(
                            order.timeStamp.seconds * 1000,
                          ).toLocaleString("fr-FR", {
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                          })}
                        </li>
                      ))}
                    </ul>
                  </Tooltip>
                </div>
              )}
            />
          )}
          <Column
            header={t("ui.sheetOne")}
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            body={(rowData) => (
              <div className="flex justify-center">
                {sentToSheet.has(rowData.id) ? (
                  <span title={t("ui.sentToSheets")}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#22c55e"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                  </span>
                ) : (
                  <span className="text-gray-300 dark:text-gray-600">—</span>
                )}
              </div>
            )}
          />
          <Column
            body={dateBodyTemplate}
            className="text-end n-date"
            header={t("orders.datatable_templating_demo.order_date")}
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
          ></Column>
          {/* <Column body={shipActionTemplate} className='text-end n-delivery' header='الشحن' ></Column>*/}
          {/* <Column field='paymentType' className='text-end n-pay' header='الدفع' ></Column>*/}
          <Column
            field={wilaya1}
            className="text-end n-wilaya"
            header={t("orders.datatable_templating_demo.wilaya")}
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
          ></Column>
          <Column
            style={{ minwidth: "125px" }}
            header={t("orders.datatable_templating_demo.order_status")}
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            className="text-end n-status1"
            body={combinedTemplate}
          ></Column>
          {/* <Column className='text-end' header='حالة الدفع' body={paidBodyTemplate} ></Column>*/}
          <Column
            style={{ color: "#6e4881" }}
            body={orderTotal}
            className="text-end n-total"
            header={t("orders.datatable_templating_demo.total")}
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
          ></Column>
          <Column
            header=""
            className="text-end n-delet"
            body={actionTemplate}
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300 dark:!border-[#3c3a3d]"
          ></Column>

          <Column expander style={{ width: "0em" }} />
        </DataTable>
      </div>

      <div className="d-flex justify-content-center  dark:!bg-[#181919]">
        {
          <Stack spacing={2} dir="ltr">
            <Pagination
              count={count}
              size="large"
              page={page}
              variant="outlined"
              shape="rounded"
              onChange={handleChange}
              color="secondary"
              sx={{
                backgroundColor: isDark ? "#181919" : "#ffffff",
                borderRadius: 2,
                p: 2,
                "& .MuiPaginationItem-root": {
                  color: isDark ? "#e1cfff" : "#000000", // Texte
                  borderColor: isDark ? "#a065c0" : "#ccc", // Bordures (si outlined)
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: isDark ? "#9b59bf" : "#9b59bf", // Background du bouton sélectionné
                  color: "#fff", // Texte sélectionné
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: isDark ? "#7c3aad" : "#f0f0f0", // Hover
                },
              }}
            />
          </Stack>
        }
      </div>
      <div className="hidden">
        <ComponentToPrint
          ref={componentRef}
          data={selectedProducts}
          store={store}
          account={account}
          products={productdata}
        />
      </div>
    </div>
  );
};

export default DataTableTemplatingDemo;
